import React, { Dispatch, SetStateAction } from 'react';

import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { FeatureSelectorType } from '@components/feature-selector/Types';
import { RetailerKpiOption, SaleType } from '@models/Products';
import { FactRevenue, ShareType, SubSection } from '@utils/pageConfig/Types';
import { ExportExploreTrendsStack } from './Types';
import { modifiedPAORSegmentExportStackChartGrandTotalToCamelCaseTotalValue } from '@utils/TotalUtils';
import ExploreTrendsMarketCard from '@components/trends-stack-market-card/ExploreTrendsMarketCard';
import ExploreTrendsRetailerCard from '@components/trends-stack-retailer-card/ExploreTrendsRetailerCard';
import CombinedMultiChartView from '@components/combined-multi-chart-view/CombinedMultiChartView';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { SortFieldDisplayProps } from '@components/design/migrated/Table';

interface Props {
  data: ExportExploreTrendsStack;
  selectedPeriodicity: Periodicity;
  factRevenue: FactRevenue;
  selectedGrowthType?: GrowthTypes;
  loadingExploreTrendsStackChart: boolean;
  selectedShareType: ShareType;
  onChangeSelectedShareType: any;
  onChangeSelectedAbsoluteType: any;
  featureHandler: () => void;
  featureSelectorType: FeatureSelectorType;
  noResultHandler: () => void;
  volume: string;
  selectedRetailerOption: RetailerKpiOption;
  setSelectedRetailerOption: Dispatch<SetStateAction<RetailerKpiOption>>;
  selectedSaleType: SaleType;
  setSelectedSaleType: Dispatch<SetStateAction<SaleType>>;
  noPeriodExistForMulticountry?: boolean;
  isExplorePage?: boolean;
  trackingTitle: string;
  stackedChartSortingOrder?: SortFieldDisplayProps;
  subSectionForAmplitudeTracking: SubSection;
}

const ExploreTrendsStackChartView: React.FC<Props> = ({
  data,
  selectedPeriodicity,
  factRevenue,
  selectedGrowthType,
  loadingExploreTrendsStackChart,
  selectedShareType,
  onChangeSelectedShareType,
  onChangeSelectedAbsoluteType,
  featureSelectorType,
  featureHandler,
  noResultHandler,
  volume,
  noPeriodExistForMulticountry,
  selectedRetailerOption,
  setSelectedRetailerOption,
  selectedSaleType,
  setSelectedSaleType,
  isExplorePage,
  trackingTitle,
  stackedChartSortingOrder,
  subSectionForAmplitudeTracking,
}) => {
  return (
    <CombinedMultiChartView
      data={data}
      transformData={modifiedPAORSegmentExportStackChartGrandTotalToCamelCaseTotalValue}
      loading={loadingExploreTrendsStackChart}
      selectedPeriodicity={selectedPeriodicity}
      factRevenue={factRevenue}
      selectedGrowthType={selectedGrowthType}
      selectedShareType={selectedShareType}
      onChangeSelectedShareType={onChangeSelectedShareType}
      featureSelectorType={featureSelectorType}
      featureHandler={featureHandler}
      noResultHandler={noResultHandler}
      volume={volume}
      selectedRetailerOption={selectedRetailerOption}
      setSelectedRetailerOption={setSelectedRetailerOption}
      saleType={selectedSaleType}
      setSaleType={setSelectedSaleType}
      noPeriodExistForMulticountry={noPeriodExistForMulticountry}
      isExplorePage={isExplorePage}
      trackingTitle={trackingTitle}
      CardMarket={ExploreTrendsMarketCard}
      CardRetailer={ExploreTrendsRetailerCard}
      marketSaleTypeProp="selectedSaleType"
      retailerSaleTypeProp="selectedSaleType"
      absoluteType={onChangeSelectedAbsoluteType}
      stackedChartSortingOrder={stackedChartSortingOrder}
      subSectionForAmplitudeTracking={subSectionForAmplitudeTracking}
    />
  );
};

export default ExploreTrendsStackChartView;
